module.exports = __webpack_public_path__ + "img/live_ag.2ac9b552.png";